"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ddd_json_1 = __importDefault(require("../utils/ddd.json"));
var isValidMobilePhone = function (phoneNumber) {
    var regex = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/;
    return regex.test(phoneNumber) && phoneNumber.replace(/\D/g, '').length === 11;
};
var validatePhone = function (value) {
    var removeMask = value.replace(/\D/g, '');
    if (value.length >= 2) {
        if (!ddd_json_1.default.includes(removeMask.substring(0, 2))) {
            return 'Por favor digite um ddd válido';
        }
    }
    var valid = isValidMobilePhone(value);
    return valid ? false : 'Número de celular inválido!';
};
exports.default = validatePhone;
//# sourceMappingURL=phone.js.map